import React from 'react'
import PropTypes from 'prop-types'
import LocationShape from './LocationShape'
import withStyle from './LocationShape.style'

const BlankLocationKnownShape = ({
  selected,
  location,
  dimensions,
  dashboardType,
  detail,
}) => (
  <LocationShape
    location={location}
    dashboardType={dashboardType}
    detail={detail}
    selected={selected}
    dimensions={dimensions}
  />
)

BlankLocationKnownShape.propTypes = {
  dashboardType: PropTypes.string,
  detail: PropTypes.string,
  location: PropTypes.string,
  selected: PropTypes.bool,
  dimensions: PropTypes.object,
}

export default withStyle(BlankLocationKnownShape)
